import { render, staticRenderFns } from "./RobotOrder.vue?vue&type=template&id=02c17671&scoped=true&"
import script from "./RobotOrder.vue?vue&type=script&lang=js&"
export * from "./RobotOrder.vue?vue&type=script&lang=js&"
import style0 from "./RobotOrder.vue?vue&type=style&index=0&id=02c17671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c17671",
  null
  
)

export default component.exports